// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dest-section-1{
    height: 100vh;
    width: 100%;
    /* background-image: url(../../public/images/contact/banner.png); */
    display: flex;
    background-size: contain; 
    background-position: center; 
    background-attachment: fixed;
    
    
}
.dest-section-1 h1 {
    font-size: 52px ;
    font-weight: 700;
    line-height: 100px;
    margin-bottom: -1rem;
}
.dest-section-1 h1 span{
    font-size: 160px;
}

.dest-section-1 p {
    text-align: left;
    font-weight: 400;
    width: 75%;
    margin-bottom: 1rem;
}

/* CLASS STYLES */
.dest-section-1 .banner-content {
  padding: 70px 70px;
  width: 100%;
  margin: 0 auto;
  /* margin-top: -3rem; */
}

.dest-section-1 .img_container {
  width: 100%;
  height: 100vh;
  background-attachment: fixed;
}

.dest-section-1 .destination-contact{
    font-size: 16px;
    background: transparent;
    border-radius: 0px;
    border: 2px #ffffff solid;
    color: #ffffff;
    padding: 10px 30px 10px 30px;
    font-weight: 400;
    transition: all ease .7s !important;
}
.dest-section-1 .destination-contact:hover {
    background: #FAEC24;
    color: #000000;
    border-color: transparent; 
  }
.dest-section-1 .destination-contact:active {
background: #000000;
color: #ffffff;
border-color: transparent; 
}
.dest-section-1 .destination-contact:disabled {
background: #ECE9E9;
color: #9F9F9F;
border-color: transparent; 
}





.dest-section-1.img_container {
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    background-attachment: fixed;
  }
  
  
  .dest-section-1.img_container img {
    position: absolute;
    z-index: -1;
    opacity: 1;
    /* animation: fade-out linear forwards;
    animation-timeline: view();
    animation-range: exit; */
    top: 0px;
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: center;
      
  }
  



.dest-section-2 {
    height: fit-content;
    width: 100%;
    background: #FAEC24;
    display: flex;

}

.dest-section-2 h1{
    color: #000;
    font-family: 'Poppins';
    font-weight: 700;
    font-size: 53px;
    line-height: 62px;
    text-transform: uppercase;
}
.dest-section-2 img{
    width:50%;
}
.dest-section-2 .sec-title{
    width: 50%;
    display: flex;
    flex-direction: column;
    /* align-items: center; */
    justify-content: center;
    padding-left: 6%;
}
/* .dest-section-2 .sec-title h1{
    width: 75%;
} */

.dest-section-2 .sec-title .blackline{
    height: 4px;
    width: 130px;
    background-color: rgb(0, 0, 0);
    position: relative;
    top: 2rem;
}

.dest-section-2 .sec-card{
    display: flex;
    flex-direction: column;
    width: 50%;
    text-align: center;
}
.dest-section-2 .sec-card .image-container {
    width: 100%;
    height: auto;
}
.dest-section-2 .sec-card .image-container {
    position: relative;
    width: 100%; 
    
}
.dest-section-2 .sec-card img {
    width: 100%;
    height: auto;
}

.dest-section-2 .sec-card .image-container .overlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.7);
    opacity: 0;
    transition: opacity 0.3s ease;
}

.dest-section-2 .sec-card .image-container:hover .overlay {
    opacity: 1;
}

.dest-section-2 .sec-card .image-container:hover .overlay {
    opacity: 1;
}

.dest-section-2 .sec-card .title {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    text-align: center;
    color: white;
    font-size: 32px;
    line-height: 38px;
    font-weight: 700;
    z-index: 1;
    width: 100%;
}
.dest-section-2 .sec-card .description {
    position: absolute;
    top: 60%; 
    left: 50%;
    transform: translate(-50%, -50%);
    text-align: center;
    color: white;
    font-size: 20px; 
    font-weight: 400; 
    z-index: 1;
    line-height: 38px;
}

.dest-section-2 .sec-card .line {
    position: absolute;
    top: 62%;
    left: 47%;
    transform: translateX(-50%, 50%);
    width: 0;
    height: 5px;
    background-color: #D9D9D9;
    transition: width 0.5s ease;
    transform-origin:  left;
}

.dest-section-2 .sec-card .image-container:hover .line {
    width: 42px;
}



.dest-section-3{
    height: fit-content;
    width: 100%;
    background: #000000;
    color: #fff;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding-top: 100px;
    padding-bottom: 100px;
    text-align: center;
    
}
.dest-section-3 .sec-content {
    width: 66%;
}
.dest-section-3 .sec-content p{
    width: 100%;
    font-size: 36px;
    line-height: 47px;
    font-weight: 600;
    text-align: left;
}

.dest-section-4{
    height: fit-content;
    width: 100%;
    background: #ffffff;
    display: flex;

}

.dest-section-4 h1{
    color: #000;
    font-family: 'Poppins';
    font-weight: 700;
    font-size: 40px;
    line-height: 44px;
}
.dest-section-4 img{
    width:50%;
}
.dest-section-4 .yellowline{
    width: 130px;
    height: 4px;
    background-color: #FAEC24;
    position: relative;
    bottom: 20px;
    
}
.dest-section-4  .sec-title{
    width: 50%;
    display: flex;
    flex-direction: column;
    /* align-items: center; */
    justify-content: center;
    padding-left: 6%;
    padding-right: 6%;
}
.dest-section-4  .sec-title p{
    text-align: left;
    padding-top: 2rem;
}


  

/* @keyframes fade-out {
  50% { 
    transform: scale(1.2);
    opacity: 0;
   }
   100% { 
    transform: scale(1);
    opacity: 0;
   }
 
} */

.dest-section-1 p{
    width: 65%;
}
@media (min-width:1400px) {
    .dest-section-1 p{
        width: 50%;
    }
    .dest-section-3 .sec-content {
        width: 71%;
    }
}



@media (min-width:768px) and (max-width:992px) {
    .dest-section-1 p {
        font-size: 17px;
        line-height: 25px;
        padding-top: 1rem;
        width: 85%;
    }
    .dest-section-2{
        flex-direction: column;
    }

    .dest-section-2 img{
        width: 100%;
        height: 80%;
    }
    .dest-section-2 .sec-card {
        width: 100%;
    }
    .dest-section-2 .sec-title{
        width: 100%;
        height: 450px;
        position: relative;
        bottom: 1rem;
    }
    .dest-section-3 .sec-content p{
        font-size: 30px !important;
        line-height: 38px !important;
    }
    .dest-section-4 {
        flex-direction: column;
    }
    .dest-section-4 img {
        width: 100%;
    }
    .dest-section-4 .sec-title{
        width: 100%;
        padding-top: 7rem;
        padding-bottom: 7rem;
        padding-right: 7rem;
        padding-left: 7rem;
    }
    .dest-section-2 .sec-card .line{
        width: 41px !important;
        margin-left: 0;
        /* left: 44%; */
        transform: translateX(-50%, 50%);
    }
    
}
 

@media (max-width:576px) {
    .dest-section-1 .banner-content{
        padding: 20px 20px;
        margin-top: 4rem;
    }
    .dest-section-1 h1{
        line-height: 56px;
        font-size: 28px;
    }
    .dest-section-1 h1 span {
        font-size: 65px;
        
    }
    .dest-section-1 p{
        margin-top: 1rem;
        width: 93%;
    }

    .dest-section-2{
        flex-direction: column;
    }
    .dest-section-2 h1 {
        font-size: 34px;
        line-height: 40px;
    }
    .dest-section-2 img{
        width: 100%;
        height: 80%;
    }
    .dest-section-2 .sec-card {
        width: 100%;
    }
    .dest-section-2 .sec-title{
        width: 100%;
        height: 299px;
        position: relative;
        bottom: 1rem;
    }
    .dest-section-3 .sec-content {
        width: 87%;
    }
    .dest-section-3 .sec-content p{
        font-size: 26px ;
        line-height: 32px ;
    }
    .dest-section-4 {
        flex-direction: column;
    }
    .dest-section-4 img {
        width: 100%;
    }
    .dest-section-4 .sec-title{
        width: 100%;
        padding-top: 7rem;
        padding-bottom: 5rem;
       
    }
    .dest-section-4 h1,.row.sec-title .yellow-line{
        font-size: 32px;
        line-height: 38px;
    }
    .dest-section-2 .sec-card .description {
        width: 100%;
    }
    .dest-section-2 .sec-card .line{
        width: 41px;
        margin-left: 0;
        left: 44%;
        transform: translateX(-50%, 50%);
    }
}`, "",{"version":3,"sources":["webpack://./src/common-componets/Destinations/Destination.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,WAAW;IACX,mEAAmE;IACnE,aAAa;IACb,wBAAwB;IACxB,2BAA2B;IAC3B,4BAA4B;;;AAGhC;AACA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;IAClB,oBAAoB;AACxB;AACA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,UAAU;IACV,mBAAmB;AACvB;;AAEA,iBAAiB;AACjB;EACE,kBAAkB;EAClB,WAAW;EACX,cAAc;EACd,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,4BAA4B;AAC9B;;AAEA;IACI,eAAe;IACf,uBAAuB;IACvB,kBAAkB;IAClB,yBAAyB;IACzB,cAAc;IACd,4BAA4B;IAC5B,gBAAgB;IAChB,mCAAmC;AACvC;AACA;IACI,mBAAmB;IACnB,cAAc;IACd,yBAAyB;EAC3B;AACF;AACA,mBAAmB;AACnB,cAAc;AACd,yBAAyB;AACzB;AACA;AACA,mBAAmB;AACnB,cAAc;AACd,yBAAyB;AACzB;;;;;;AAMA;IACI,kBAAkB;IAClB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,4BAA4B;EAC9B;;;EAGA;IACE,kBAAkB;IAClB,WAAW;IACX,UAAU;IACV;;4BAEwB;IACxB,QAAQ;IACR,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,uBAAuB;;EAEzB;;;;;AAKF;IACI,mBAAmB;IACnB,WAAW;IACX,mBAAmB;IACnB,aAAa;;AAEjB;;AAEA;IACI,WAAW;IACX,sBAAsB;IACtB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,yBAAyB;AAC7B;AACA;IACI,SAAS;AACb;AACA;IACI,UAAU;IACV,aAAa;IACb,sBAAsB;IACtB,yBAAyB;IACzB,uBAAuB;IACvB,gBAAgB;AACpB;AACA;;GAEG;;AAEH;IACI,WAAW;IACX,YAAY;IACZ,8BAA8B;IAC9B,kBAAkB;IAClB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,UAAU;IACV,kBAAkB;AACtB;AACA;IACI,WAAW;IACX,YAAY;AAChB;AACA;IACI,kBAAkB;IAClB,WAAW;;AAEf;AACA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,oCAAoC;IACpC,UAAU;IACV,6BAA6B;AACjC;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,gCAAgC;IAChC,kBAAkB;IAClB,YAAY;IACZ,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,UAAU;IACV,WAAW;AACf;AACA;IACI,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,gCAAgC;IAChC,kBAAkB;IAClB,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,UAAU;IACV,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,gCAAgC;IAChC,QAAQ;IACR,WAAW;IACX,yBAAyB;IACzB,2BAA2B;IAC3B,uBAAuB;AAC3B;;AAEA;IACI,WAAW;AACf;;;;AAIA;IACI,mBAAmB;IACnB,WAAW;IACX,mBAAmB;IACnB,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,qBAAqB;IACrB,kBAAkB;;AAEtB;AACA;IACI,UAAU;AACd;AACA;IACI,WAAW;IACX,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,WAAW;IACX,mBAAmB;IACnB,aAAa;;AAEjB;;AAEA;IACI,WAAW;IACX,sBAAsB;IACtB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;AACrB;AACA;IACI,SAAS;AACb;AACA;IACI,YAAY;IACZ,WAAW;IACX,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;;AAEhB;AACA;IACI,UAAU;IACV,aAAa;IACb,sBAAsB;IACtB,yBAAyB;IACzB,uBAAuB;IACvB,gBAAgB;IAChB,iBAAiB;AACrB;AACA;IACI,gBAAgB;IAChB,iBAAiB;AACrB;;;;;AAKA;;;;;;;;;;GAUG;;AAEH;IACI,UAAU;AACd;AACA;IACI;QACI,UAAU;IACd;IACA;QACI,UAAU;IACd;AACJ;;;;AAIA;IACI;QACI,eAAe;QACf,iBAAiB;QACjB,iBAAiB;QACjB,UAAU;IACd;IACA;QACI,sBAAsB;IAC1B;;IAEA;QACI,WAAW;QACX,WAAW;IACf;IACA;QACI,WAAW;IACf;IACA;QACI,WAAW;QACX,aAAa;QACb,kBAAkB;QAClB,YAAY;IAChB;IACA;QACI,0BAA0B;QAC1B,4BAA4B;IAChC;IACA;QACI,sBAAsB;IAC1B;IACA;QACI,WAAW;IACf;IACA;QACI,WAAW;QACX,iBAAiB;QACjB,oBAAoB;QACpB,mBAAmB;QACnB,kBAAkB;IACtB;IACA;QACI,sBAAsB;QACtB,cAAc;QACd,eAAe;QACf,gCAAgC;IACpC;;AAEJ;;;AAGA;IACI;QACI,kBAAkB;QAClB,gBAAgB;IACpB;IACA;QACI,iBAAiB;QACjB,eAAe;IACnB;IACA;QACI,eAAe;;IAEnB;IACA;QACI,gBAAgB;QAChB,UAAU;IACd;;IAEA;QACI,sBAAsB;IAC1B;IACA;QACI,eAAe;QACf,iBAAiB;IACrB;IACA;QACI,WAAW;QACX,WAAW;IACf;IACA;QACI,WAAW;IACf;IACA;QACI,WAAW;QACX,aAAa;QACb,kBAAkB;QAClB,YAAY;IAChB;IACA;QACI,UAAU;IACd;IACA;QACI,gBAAgB;QAChB,kBAAkB;IACtB;IACA;QACI,sBAAsB;IAC1B;IACA;QACI,WAAW;IACf;IACA;QACI,WAAW;QACX,iBAAiB;QACjB,oBAAoB;;IAExB;IACA;QACI,eAAe;QACf,iBAAiB;IACrB;IACA;QACI,WAAW;IACf;IACA;QACI,WAAW;QACX,cAAc;QACd,SAAS;QACT,gCAAgC;IACpC;AACJ","sourcesContent":[".dest-section-1{\r\n    height: 100vh;\r\n    width: 100%;\r\n    /* background-image: url(../../public/images/contact/banner.png); */\r\n    display: flex;\r\n    background-size: contain; \r\n    background-position: center; \r\n    background-attachment: fixed;\r\n    \r\n    \r\n}\r\n.dest-section-1 h1 {\r\n    font-size: 52px ;\r\n    font-weight: 700;\r\n    line-height: 100px;\r\n    margin-bottom: -1rem;\r\n}\r\n.dest-section-1 h1 span{\r\n    font-size: 160px;\r\n}\r\n\r\n.dest-section-1 p {\r\n    text-align: left;\r\n    font-weight: 400;\r\n    width: 75%;\r\n    margin-bottom: 1rem;\r\n}\r\n\r\n/* CLASS STYLES */\r\n.dest-section-1 .banner-content {\r\n  padding: 70px 70px;\r\n  width: 100%;\r\n  margin: 0 auto;\r\n  /* margin-top: -3rem; */\r\n}\r\n\r\n.dest-section-1 .img_container {\r\n  width: 100%;\r\n  height: 100vh;\r\n  background-attachment: fixed;\r\n}\r\n\r\n.dest-section-1 .destination-contact{\r\n    font-size: 16px;\r\n    background: transparent;\r\n    border-radius: 0px;\r\n    border: 2px #ffffff solid;\r\n    color: #ffffff;\r\n    padding: 10px 30px 10px 30px;\r\n    font-weight: 400;\r\n    transition: all ease .7s !important;\r\n}\r\n.dest-section-1 .destination-contact:hover {\r\n    background: #FAEC24;\r\n    color: #000000;\r\n    border-color: transparent; \r\n  }\r\n.dest-section-1 .destination-contact:active {\r\nbackground: #000000;\r\ncolor: #ffffff;\r\nborder-color: transparent; \r\n}\r\n.dest-section-1 .destination-contact:disabled {\r\nbackground: #ECE9E9;\r\ncolor: #9F9F9F;\r\nborder-color: transparent; \r\n}\r\n\r\n\r\n\r\n\r\n\r\n.dest-section-1.img_container {\r\n    position: relative;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    width: 100%;\r\n    background-attachment: fixed;\r\n  }\r\n  \r\n  \r\n  .dest-section-1.img_container img {\r\n    position: absolute;\r\n    z-index: -1;\r\n    opacity: 1;\r\n    /* animation: fade-out linear forwards;\r\n    animation-timeline: view();\r\n    animation-range: exit; */\r\n    top: 0px;\r\n    width: 100%;\r\n    height: 100%;\r\n    object-fit: cover;\r\n    object-position: center;\r\n      \r\n  }\r\n  \r\n\r\n\r\n\r\n.dest-section-2 {\r\n    height: fit-content;\r\n    width: 100%;\r\n    background: #FAEC24;\r\n    display: flex;\r\n\r\n}\r\n\r\n.dest-section-2 h1{\r\n    color: #000;\r\n    font-family: 'Poppins';\r\n    font-weight: 700;\r\n    font-size: 53px;\r\n    line-height: 62px;\r\n    text-transform: uppercase;\r\n}\r\n.dest-section-2 img{\r\n    width:50%;\r\n}\r\n.dest-section-2 .sec-title{\r\n    width: 50%;\r\n    display: flex;\r\n    flex-direction: column;\r\n    /* align-items: center; */\r\n    justify-content: center;\r\n    padding-left: 6%;\r\n}\r\n/* .dest-section-2 .sec-title h1{\r\n    width: 75%;\r\n} */\r\n\r\n.dest-section-2 .sec-title .blackline{\r\n    height: 4px;\r\n    width: 130px;\r\n    background-color: rgb(0, 0, 0);\r\n    position: relative;\r\n    top: 2rem;\r\n}\r\n\r\n.dest-section-2 .sec-card{\r\n    display: flex;\r\n    flex-direction: column;\r\n    width: 50%;\r\n    text-align: center;\r\n}\r\n.dest-section-2 .sec-card .image-container {\r\n    width: 100%;\r\n    height: auto;\r\n}\r\n.dest-section-2 .sec-card .image-container {\r\n    position: relative;\r\n    width: 100%; \r\n    \r\n}\r\n.dest-section-2 .sec-card img {\r\n    width: 100%;\r\n    height: auto;\r\n}\r\n\r\n.dest-section-2 .sec-card .image-container .overlay {\r\n    position: absolute;\r\n    top: 0;\r\n    left: 0;\r\n    width: 100%;\r\n    height: 100%;\r\n    background-color: rgba(0, 0, 0, 0.7);\r\n    opacity: 0;\r\n    transition: opacity 0.3s ease;\r\n}\r\n\r\n.dest-section-2 .sec-card .image-container:hover .overlay {\r\n    opacity: 1;\r\n}\r\n\r\n.dest-section-2 .sec-card .image-container:hover .overlay {\r\n    opacity: 1;\r\n}\r\n\r\n.dest-section-2 .sec-card .title {\r\n    position: absolute;\r\n    top: 50%;\r\n    left: 50%;\r\n    transform: translate(-50%, -50%);\r\n    text-align: center;\r\n    color: white;\r\n    font-size: 32px;\r\n    line-height: 38px;\r\n    font-weight: 700;\r\n    z-index: 1;\r\n    width: 100%;\r\n}\r\n.dest-section-2 .sec-card .description {\r\n    position: absolute;\r\n    top: 60%; \r\n    left: 50%;\r\n    transform: translate(-50%, -50%);\r\n    text-align: center;\r\n    color: white;\r\n    font-size: 20px; \r\n    font-weight: 400; \r\n    z-index: 1;\r\n    line-height: 38px;\r\n}\r\n\r\n.dest-section-2 .sec-card .line {\r\n    position: absolute;\r\n    top: 62%;\r\n    left: 47%;\r\n    transform: translateX(-50%, 50%);\r\n    width: 0;\r\n    height: 5px;\r\n    background-color: #D9D9D9;\r\n    transition: width 0.5s ease;\r\n    transform-origin:  left;\r\n}\r\n\r\n.dest-section-2 .sec-card .image-container:hover .line {\r\n    width: 42px;\r\n}\r\n\r\n\r\n\r\n.dest-section-3{\r\n    height: fit-content;\r\n    width: 100%;\r\n    background: #000000;\r\n    color: #fff;\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items: center;\r\n    justify-content: center;\r\n    padding-top: 100px;\r\n    padding-bottom: 100px;\r\n    text-align: center;\r\n    \r\n}\r\n.dest-section-3 .sec-content {\r\n    width: 66%;\r\n}\r\n.dest-section-3 .sec-content p{\r\n    width: 100%;\r\n    font-size: 36px;\r\n    line-height: 47px;\r\n    font-weight: 600;\r\n    text-align: left;\r\n}\r\n\r\n.dest-section-4{\r\n    height: fit-content;\r\n    width: 100%;\r\n    background: #ffffff;\r\n    display: flex;\r\n\r\n}\r\n\r\n.dest-section-4 h1{\r\n    color: #000;\r\n    font-family: 'Poppins';\r\n    font-weight: 700;\r\n    font-size: 40px;\r\n    line-height: 44px;\r\n}\r\n.dest-section-4 img{\r\n    width:50%;\r\n}\r\n.dest-section-4 .yellowline{\r\n    width: 130px;\r\n    height: 4px;\r\n    background-color: #FAEC24;\r\n    position: relative;\r\n    bottom: 20px;\r\n    \r\n}\r\n.dest-section-4  .sec-title{\r\n    width: 50%;\r\n    display: flex;\r\n    flex-direction: column;\r\n    /* align-items: center; */\r\n    justify-content: center;\r\n    padding-left: 6%;\r\n    padding-right: 6%;\r\n}\r\n.dest-section-4  .sec-title p{\r\n    text-align: left;\r\n    padding-top: 2rem;\r\n}\r\n\r\n\r\n  \r\n\r\n/* @keyframes fade-out {\r\n  50% { \r\n    transform: scale(1.2);\r\n    opacity: 0;\r\n   }\r\n   100% { \r\n    transform: scale(1);\r\n    opacity: 0;\r\n   }\r\n \r\n} */\r\n\r\n.dest-section-1 p{\r\n    width: 65%;\r\n}\r\n@media (min-width:1400px) {\r\n    .dest-section-1 p{\r\n        width: 50%;\r\n    }\r\n    .dest-section-3 .sec-content {\r\n        width: 71%;\r\n    }\r\n}\r\n\r\n\r\n\r\n@media (min-width:768px) and (max-width:992px) {\r\n    .dest-section-1 p {\r\n        font-size: 17px;\r\n        line-height: 25px;\r\n        padding-top: 1rem;\r\n        width: 85%;\r\n    }\r\n    .dest-section-2{\r\n        flex-direction: column;\r\n    }\r\n\r\n    .dest-section-2 img{\r\n        width: 100%;\r\n        height: 80%;\r\n    }\r\n    .dest-section-2 .sec-card {\r\n        width: 100%;\r\n    }\r\n    .dest-section-2 .sec-title{\r\n        width: 100%;\r\n        height: 450px;\r\n        position: relative;\r\n        bottom: 1rem;\r\n    }\r\n    .dest-section-3 .sec-content p{\r\n        font-size: 30px !important;\r\n        line-height: 38px !important;\r\n    }\r\n    .dest-section-4 {\r\n        flex-direction: column;\r\n    }\r\n    .dest-section-4 img {\r\n        width: 100%;\r\n    }\r\n    .dest-section-4 .sec-title{\r\n        width: 100%;\r\n        padding-top: 7rem;\r\n        padding-bottom: 7rem;\r\n        padding-right: 7rem;\r\n        padding-left: 7rem;\r\n    }\r\n    .dest-section-2 .sec-card .line{\r\n        width: 41px !important;\r\n        margin-left: 0;\r\n        /* left: 44%; */\r\n        transform: translateX(-50%, 50%);\r\n    }\r\n    \r\n}\r\n \r\n\r\n@media (max-width:576px) {\r\n    .dest-section-1 .banner-content{\r\n        padding: 20px 20px;\r\n        margin-top: 4rem;\r\n    }\r\n    .dest-section-1 h1{\r\n        line-height: 56px;\r\n        font-size: 28px;\r\n    }\r\n    .dest-section-1 h1 span {\r\n        font-size: 65px;\r\n        \r\n    }\r\n    .dest-section-1 p{\r\n        margin-top: 1rem;\r\n        width: 93%;\r\n    }\r\n\r\n    .dest-section-2{\r\n        flex-direction: column;\r\n    }\r\n    .dest-section-2 h1 {\r\n        font-size: 34px;\r\n        line-height: 40px;\r\n    }\r\n    .dest-section-2 img{\r\n        width: 100%;\r\n        height: 80%;\r\n    }\r\n    .dest-section-2 .sec-card {\r\n        width: 100%;\r\n    }\r\n    .dest-section-2 .sec-title{\r\n        width: 100%;\r\n        height: 299px;\r\n        position: relative;\r\n        bottom: 1rem;\r\n    }\r\n    .dest-section-3 .sec-content {\r\n        width: 87%;\r\n    }\r\n    .dest-section-3 .sec-content p{\r\n        font-size: 26px ;\r\n        line-height: 32px ;\r\n    }\r\n    .dest-section-4 {\r\n        flex-direction: column;\r\n    }\r\n    .dest-section-4 img {\r\n        width: 100%;\r\n    }\r\n    .dest-section-4 .sec-title{\r\n        width: 100%;\r\n        padding-top: 7rem;\r\n        padding-bottom: 5rem;\r\n       \r\n    }\r\n    .dest-section-4 h1,.row.sec-title .yellow-line{\r\n        font-size: 32px;\r\n        line-height: 38px;\r\n    }\r\n    .dest-section-2 .sec-card .description {\r\n        width: 100%;\r\n    }\r\n    .dest-section-2 .sec-card .line{\r\n        width: 41px;\r\n        margin-left: 0;\r\n        left: 44%;\r\n        transform: translateX(-50%, 50%);\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
